import { Button } from "@mui/material"
import { useParams } from "react-router-dom"
import { CompareEmptyState } from "routes/schedule/compare/compare-empty-state"
import { getCompareDestinationId } from "routes/schedule/compare/lib/get-compare-destination-id"

const documentNames = {
    destination: "your schedule",
    source: "the version your schedule was created from",
    other: "the original schedule",
}

export function ComparisonLoadFailed({ failed, retry }) {
    const { destination } = useParams()
    return (
        <CompareEmptyState
            id={getCompareDestinationId(destination)}
            title="Couldn't load the comparison"
            detail={`Something went wrong loading ${documentNames[failed]}.`}
        >
            <Button sx={{ mt: 2 }} variant="outlined" onClick={retry} data-cy="compare-retry">
                Try again
            </Button>
        </CompareEmptyState>
    )
}
